import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  textLink: theme => css`
    cursor: pointer;
    color: ${theme.colors.brand.primary[300]};
  `,
})

export default useStyles
